import { clientFetch } from 'app/utils/client-fetch';
import config from 'app/config';

export const apiGetBundle = (bundleName = config.PROJECT_NAME) => {
    return clientFetch({
        url: `${config.CMX_API_URL}/bundle/${bundleName}`,
        method: 'POST'
    });
};
